import type { WrapperFC } from '@george-labs.com/design-system';
import { OverviewCardMenu } from '@george-labs.com/design-system';

import { getActionsDropdownConfig } from '@shared/products-core';

import type { ActivePAPIProductWithAvatarData } from '../personalization-card/types';
import type { ActionsDropdownContentProps } from './ActionsDropdownContent';
import { ActivePAPIProductProvider } from '../../ActivePAPIProductContext';
import { ActiveProductServicesProvider } from '../../ActiveProductServicesContext';
import { ActionsDropdownContent } from './ActionsDropdownContent';

const NOOP_UPDATE_CACHE = () => {};

export const ActionsDropdown: WrapperFC<ActionsDropdownContentProps> = (props) => {
    const { account } = props;

    const config = getActionsDropdownConfig(account.registerType);
    const papiProduct = config?.synthesizePapiProduct(account) as
        | ActivePAPIProductWithAvatarData
        | undefined;

    if (!papiProduct) {
        return null;
    }

    return (
        <ActivePAPIProductProvider value={papiProduct}>
            <ActiveProductServicesProvider
                value={{ updateCache: config?.updateCache ?? NOOP_UPDATE_CACHE }}
            >
                <ActionsDropdownContent {...props} />
            </ActiveProductServicesProvider>
        </ActivePAPIProductProvider>
    );
};

ActionsDropdown.wrapsComponent = OverviewCardMenu;
